<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

        <!-- 正常页面 -->
        <div v-else class="order-page">
            <div class="order-content">
                <!-- 选择学生 -->
                <section class="order-section">
                    <div class="section-title">
                        选择学生
                        <span class="add-student" @click="showAddStudent = true"><van-icon name="plus" /> 新增学生</span>
                    </div>
                    <div class="student-list">
                        <div :class="['student-card', item.isSelected ? 'selected' : '']" v-for="item in studentList"
                            :key="item.id" @click="handleStudentClick(item)">
                            <van-image round fit="cover" class="avatar"
                                :src="Object.keys(item.face_image_arr || {}).length > 0 ? item.face_image_arr.face_image_url : userDefaultImage" />
                            <div class="info">
                                <div class="name-row">
                                    {{ item.name }}
                                    <div class="status-tags">
                                        <van-tag class="status-tag milk-tag" color="#DCFCE7" text-color="#16A34A" round
                                            v-if="item.milk_state === '已订奶'">
                                            已订奶
                                        </van-tag>
                                        <van-tag class="status-tag milk-tag" color="#F3F4F6" text-color="#4B5563" round
                                            v-if="item.milk_state === '未订奶'">
                                            未订奶
                                        </van-tag>
                                    </div>
                                </div>
                                <div class="desc">{{ item.school_name }} {{ item.grade_name }} {{ item.class_name }}
                                </div>
                                <div class="tag-box">
                                    <van-tag class="tag" color="#DCFCE7" text-color="#16A34A" round
                                        v-if="Object.keys(item.face_image_arr || {}).length > 0">已录脸</van-tag>
                                    <div class="tag-box" v-else>
                                        <van-tag class="tag" color="#FEF9C3" text-color="#CA8A04" round>未录脸</van-tag>
                                        <div class="go-face">
                                            <van-icon name="photograph" class="go-face-icon" />
                                            <span class="go-face-text" @click.stop="handleGoFace(item)">去录入</span>
                                        </div>
                                    </div>
                                    <div class="go-face">
                                        <van-icon name="edit" class="go-face-icon" />
                                        <span class="go-edit-text" @click.stop="handleGoEdit(item)">修改</span>
                                    </div>
                                </div>
                            </div>
                            <van-icon name="success" class="success-icon" color="#8B0000" v-if="item.isSelected" />
                        </div>
                    </div>
                </section>

                <!-- 订购套餐 -->
				<section class="order-section">
					<div class="section-title">订购套餐</div>
					<div class="order-card selected">
						<span>{{ packageInfo.name }}</span>
						<span class="price" v-if="!selectedPeriod?.is_present_card">￥{{periodList.find(item => item.isSelected)?.product_price || 0}}/瓶</span>
						<span class="price" v-else>￥{{periodList.find(item => item.isSelected)?.actual_amount || 0}}</span>
					</div>
				</section>

                <!-- 订购周期 -->
                <section class="order-section">
                    <div class="section-title">订购周期</div>
                    <div class="period-list">
                        <div class="period-item" :class="{ 'selected': item.isSelected }" v-for="item in periodList"
                            :key="item.id" @click="handlePeriodClick(item)">
                            <div>{{ item.name }}</div>
                            <!-- <div class="period-tip">{{ item.days }}天</div> -->
                        </div>
                    </div>
                </section>

                <!-- 订购说明 -->
                <section class="order-section">
                    <div class="section-title">订购说明</div>
                    <ul class="order-desc">
                        <li>{{ packageInfo.description_sale }}</li>
                    </ul>
                </section>

                <!-- 配送奶品类型 -->
                <section class="order-section" v-if="!selectedPeriod?.is_present_card">
                    <div class="section-title">配送奶品类型</div>
                    <div class="milk-type-tip" v-if="packageInfo.is_amend">点击牛奶图标，更换鲜奶/酸奶口味</div>
                    <div class="milk-week-list">
                        <div class="milk-week-item" v-for="(item, idx) in milkTypes" :key="item.week">
                            <div class="milk-week-card">
                                <div class="milk-week-title">{{ item.week }}</div>
                                <div class="milk-type-tag" :style="{ background: milkTypeMap[item.type].tagBg }">
                                    {{ milkTypeMap[item.type].label }}
                                </div>
                                <img class="milk-icon" :src="milkTypeMap[item.type].img" @click="toggleMilkType(idx)" />
                                <div class="milk-label" :style="{ color: milkTypeMap[item.type].color }">
                                    {{ milkTypeMap[item.type].text }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- 赠送卡片 -->
                <section class="order-section" v-if="selectedPeriod?.give_card_info">
                    <div class="section-title">套卡卡片</div>
                    <div class="gift-tip">购买成功后以下卡片自动存入账户</div>
                    <div class="gift-card">
                        <div class="gift-icon-wrap">
                            <van-icon name="gift-o" class="gift-icon" />
                        </div>
                        <div class="gift-info">
                            <div class="gift-title-row">
                                <span class="gift-name">{{ selectedPeriod.give_card_info.name }}</span>
                                <van-tag class="gift-tag" color="#EFF6FF" text-color="#2563EB" round>
                                    {{ selectedPeriod.give_card_info.category_label }}
                                </van-tag>
                            </div>
                            <div class="gift-validity">有效期：{{ selectedPeriod.give_card_info.validity_label }}</div>
                        </div>
                        <div class="gift-amount" :class="{ 'is-bottle': selectedPeriod.give_card_info.card_type === '瓶数卡' }">
                            {{ selectedPeriod.give_card_info.amount_or_bottle }}
                        </div>
                    </div>
                </section>

                <!-- 取奶机位置：仅赠送套卡的周期不显示 -->
                <section class="order-section" v-if="machineInfo.id && !selectedPeriod?.is_present_card">
                    <div class="section-title">取奶机器位置</div>
                    <div class="machine-card">
                        <van-icon name="location" color="#8B0000" class="machine-icon" />
                        <div class="machine-info">
                            <div class="machine-title">{{ machineInfo.name }}</div>
                            <div class="machine-desc">位置：{{ machineInfo.device_placement_address }}</div>
                            <!-- <div class="machine-note">备注：靠近一年级教室，有明显标识</div> -->
                        </div>
                    </div>
                </section>

                <!-- 授权录脸 -->
                <section class="order-section" v-if="shouldShowAuthFace">
                    <div class="auth-face-section">
                        <van-checkbox v-model="authFaceRecording" class="auth-checkbox" shape="square">
                            <span class="auth-text">授权学校为订购学生录脸</span>
                        </van-checkbox>
                    </div>
                </section>

            </div>
            <!-- 总计与按钮 -->
            <div class="order-footer">
                <div class="total">
                    <span class="total-text">总计金额</span>
                    <span class="price">￥{{periodList.find(item => item.isSelected)?.actual_amount || 0}}</span>
                </div>
                <van-button type="primary" block round class="order-btn" :disabled="!canOrder"
                    @click="handleOrder">立即预订</van-button>
            </div>
        </div>

        <!-- 新增学生弹框 -->
        <AddStudentModal v-model:show="showAddStudent" @submit="handleAddStudent" />
        <!-- 编辑学生弹框 -->
        <AddStudentModal v-model:show="showEditStudent" mode="edit" :edit-data="currentEditStudent"
            @submit="handleEditStudent" />
    </PageLoading>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { setWxTitle } from '@/utils/wx'
import AddStudentModal from '@/components/AddStudentModal.vue'
import { post } from '@/utils/request'
import { Toast } from 'vant'
// 这里的代码在组件创建时立即执行（相当于created）
setWxTitle('订购套餐')
// 加载状态
const loading = ref(true)
// 用户默认头像
const userDefaultImage = ref(localStorage.getItem('user_default_image'))

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

const showAddStudent = ref(false)
const showEditStudent = ref(false)
const currentEditStudent = ref(null)
const userInfo = ref({})
const studentList = ref([])
const packageInfo = ref({})
// 选择订购周期
const periodList = ref([])
// 口味分类 周一到周日
const milkTypeList = ref([])
// 牛奶口味数据
const milkTypes = ref([])

const milkTypeMap = {
    fresh: {
        label: '鲜',
        text: '鲜奶',
        color: '#3B82F6',
        img: require('@/assets/milk-fresh.png'),
        tagBg: '#3B82F6',
    },
    yogurt: {
        label: '酸',
        text: '酸奶',
        color: '#D50F5F',
        img: require('@/assets/milk-yogurt.png'),
        tagBg: '#D50F5F',
    },
}
// 机器信息
const machineInfo = ref({})

// 授权录脸状态
const authFaceRecording = ref(false)

// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}

const addMilkType = (week, list) => {
    if (list) {
        milkTypes.value.push({
            week: week,
            type: list.name === '鲜奶' ? 'fresh' : 'yogurt',
            id: list.id,
        })
    }
}

// 页面初始化
const initPage = async (studentId = null) => {
    milkTypes.value = []
    try {
        const data = {
            partner_id: parseInt(localStorage.getItem('userId')),
            company_ids: JSON.parse(localStorage.getItem('company_ids')),
        }
        const urlParams = new URLSearchParams(window.location.search)
        if (studentId) {
            data.student_id = studentId
        } else if (urlParams.get('student_id')) {
            data.student_id = parseInt(urlParams.get('student_id'))
        }
        const res = await post('/api/select/school/package', data)

        if (res.result && res.result.state === 'ok') {
            userInfo.value = res.result.partner_info || {}
            studentList.value = res.result.partner_info.student_ids || []
            if (Object.keys(res.result.selected_student_info || {}).length > 0) {
                studentList.value.forEach(item => {
                    if (item.id === res.result.selected_student_info.id) {
                        item.isSelected = true
                    }
                })
            }
            packageInfo.value = res.result.product_info || {}
            periodList.value = (packageInfo.value?.term_arr || []).map((item, idx) => ({
                ...item,
                isSelected: idx === 0,
            }))
            // 一周口味选择
            addMilkType('周一', packageInfo.value.monday_list)
            addMilkType('周二', packageInfo.value.tuesday_list)
            addMilkType('周三', packageInfo.value.wednesday_list)
            addMilkType('周四', packageInfo.value.thursday_list)
            addMilkType('周五', packageInfo.value.friday_list)
            addMilkType('周六', packageInfo.value.saturday_list)
            addMilkType('周日', packageInfo.value.sunday_list)
            milkTypeList.value = res.result.category_arr || []
            machineInfo.value = res.result.machine_info || {}
        } else {
            handleError('获取订购套餐失败', res.result?.message || '接口异常')
        }

    } catch (error) {
        console.error('页面初始化失败:', error)
        handleError('加载失败', '页面加载失败，请重试')
    } finally {
        loading.value = false
    }
}
// 执行方法
initPage()

onMounted(() => {
    console.log('onMounted')
})

// 当前选中的订购周期：默认第一个（idx==0 isSelected=true），切换后联动更新
const selectedPeriod = computed(() => {
    return periodList.value.find(item => item.isSelected) || null
})

// 选择学生和订购周期之后可预定,如果显示授权录脸，则需要授权录脸
const canOrder = computed(() => {
    return studentList.value.some(item => item.isSelected) && periodList.value.some(item => item.isSelected)
})

// 选择学生
const handleStudentClick = (item) => {
    studentList.value.forEach(stu => { stu.isSelected = false })
    item.isSelected = true
    initPage(item.id)
}

const handlePeriodClick = (item) => {
    periodList.value.forEach(period => { period.isSelected = false })
    item.isSelected = true
}

const toggleMilkType = (idx) => {
    if (packageInfo.value.is_amend) {
        milkTypes.value[idx].type = milkTypes.value[idx].type === 'fresh' ? 'yogurt' : 'fresh'
        milkTypes.value[idx].id = milkTypeList.value.find(item => item.name === (milkTypes.value[idx].type === 'fresh' ? '鲜奶' : '酸奶'))?.id
    }
}

const handleGoFace = (item) => {
    window.location.href = `/face-recognition?partner_id=${item.id}`
}

const handleGoEdit = (student) => {
    console.log('点击编辑学生:', student)
    currentEditStudent.value = {
        id: student.id,
        name: student.name,
        // 如果学生数据中没有这些ID字段，可能需要通过其他方式获取
        school_id: student.school_id || null,
        grade_id: student.grade_id || null,
        class_id: student.class_id || null,
        parent_phone: userInfo.value.mobile || '',
        school_quota_num: student.school_quota_num || '',
        quota_num: student.quota_num || ''
    }
    showEditStudent.value = true
}

const handleEditStudent = (studentData) => {
    console.log('编辑学生数据:', studentData)
    initPage()
    showEditStudent.value = false
    currentEditStudent.value = null
}

// 处理订单提交
const handleOrder = () => {
    // 检查是否授权录脸
    if (shouldShowAuthFace.value && !authFaceRecording.value) {
        Toast('请为该学生录脸或勾选授权学校为订购学生录脸')
        return
    }
    const selectedStudent = studentList.value.find(item => item.isSelected)
    const selectedPeriod = periodList.value.find(item => item.isSelected)
    // 构建订单数据
    const orderData = {
        // 学生信息
        student_id: selectedStudent.id,
        // 套餐信息
        product_id: packageInfo.value.id,
        // 订购周期信息
        term_id: selectedPeriod.id,
        // 牛奶口味配置
        milk_types: milkTypes.value,
        // 机器信息
        device_id: machineInfo.value.id,
        // 授权录脸
        auth_face_recording: authFaceRecording.value,
    }
    // 将数据编码为Base64以减少长度
    const encodedData = btoa(encodeURIComponent(JSON.stringify(orderData)))
    // 跳转到支付页面
    window.location.href = `/payment?data=${encodedData}`
}

// 处理新增学生
const handleAddStudent = (studentData) => {
    console.log('新增学生数据:', studentData)
    // 这里可以调用API添加学生
    // 添加成功后可以刷新学生列表
    initPage()
}

// 判断是否显示授权录脸区域
const shouldShowAuthFace = computed(() => {
    // 获取选中的学生
    const selectedStudent = studentList.value.find(item => item.isSelected)
    if (!selectedStudent) {
        return false
    }

    // 检查学生是否未录脸
    const hasFaceImage = Object.keys(selectedStudent.face_image_arr || {}).length > 0
    if (hasFaceImage) {
        return false
    }

    // 检查machine_info是否有值
    const hasMachineInfo = machineInfo.value && machineInfo.value.device_id

    return hasMachineInfo
})
</script>

<style scoped>
.order-page {
    background: #fff;
    min-height: 100vh;
    padding: 14px 14px 120px 14px;
}

.order-section {
    margin: 0 0 21px 0;
    background: #fff;
    padding: 14px;
    border-radius: 7px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.section-title {
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.add-student {
    color: #4B5563;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 3px;
}

.student-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.student-card {
    display: flex;
    align-items: center;
    border: 1px solid #E5E7EB;
    border-radius: 7px;
    padding: 12px;
}

.student-card.selected {
    border: 1px solid var(--van-primary-color);
}

.avatar {
    width: 35px;
    height: 35px;
    margin-right: 9px;
}

.info {
    flex: 1;
}

.name-row {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;
}

.status-tags {
    display: flex;
    gap: 6px;
    align-items: center;
}

.status-tag {
    padding: 2px 7px;
    font-size: 11px;
}

.desc {
    color: #6B7280;
    font-size: 12px;
    margin: 2px 0 5px 0;
}

.tag {
    padding: 2px 7px;
}

.tag-box {
    display: flex;
    align-items: center;
    gap: 6px;
}

.order-card {
    border: 1px solid var(--van-primary-color);
    border-radius: 7px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 500;
}

.price {
    color: var(--van-primary-color);
}

.period-list {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.period-item {
    border: 1px solid #E5E7EB;
    border-radius: 7px;
    padding: 12px 0;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    min-width: 97px;
}

.period-item.selected {
    border: 1px solid var(--van-primary-color);
    background: #FEF2F2;
}

.period-tip {
    color: #6B7280;
    font-size: 12px;
    margin-top: 5px;
}

.milk-type-tip {
    color: #6B7280;
    font-size: 13px;
    margin-bottom: 14px;
}

.milk-week-list {
    display: flex;
    gap: 9px;
    flex-wrap: wrap;
}

.milk-week-item {
    display: flex;
    justify-content: center;
}

.milk-week-card {
    border: 1px solid #E5E7EB;
    border-radius: 7px;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 54px;
    position: relative;
}

.milk-week-title {
    font-size: 14px;
    font-weight: 500;
}

.milk-type-tag {
    position: absolute;
    top: 34px;
    right: 2px;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    border-radius: 50%;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.milk-icon {
    width: 16px;
    height: 32px;
    margin: 18px 0;
    display: block;
}

.milk-label {
    font-size: 11px;
    font-weight: 500;
}

.milk-label.fresh {
    color: #3B82F6;
}

.milk-label.yogurt {
    color: #D50F5F;
}

.gift-tip {
    color: #6B7280;
    font-size: 13px;
    margin-bottom: 14px;
}

.gift-card {
    border-radius: 7px;
    padding: 12px;
    background: rgba(254, 242, 242, 0.5);
    display: flex;
    align-items: center;
    gap: 10px;
}

.gift-icon-wrap {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
}

.gift-icon {
    font-size: 22px;
    color: #B91C1C;
}

.gift-info {
    flex: 1;
    min-width: 0;
}

.gift-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.gift-name {
    font-size: 15px;
    font-weight: 500;
    color: #1F2937;
}

.gift-tag {
    padding: 1px 8px;
    font-size: 12px;
}

.gift-validity {
    color: #6B7280;
    font-size: 12px;
}

.gift-amount {
    color: #B91C1C;
    font-size: 18px;
    font-weight: 600;
    flex-shrink: 0;
}

.gift-amount.is-bottle {
    color: #991B1B;
}

.machine-card {
    border-radius: 7px;
    padding: 10.5px;
    background: rgba(254, 242, 242, 0.5);
    display: flex;
    gap: 4px;
}

.machine-icon {
    font-size: 16px;
    margin-top: 2px;
}

.machine-title {
    color: #1F2937;
    font-size: 14px;
    font-weight: 500;
}

.machine-desc {
    color: #4B5563;
    font-size: 12px;
    margin-top: 2px;
}

.machine-note {
    color: #6B7280;
    font-size: 12px;
    margin-top: 2px;
}

.order-desc {
    color: #4B5563;
    font-size: 12px;
    line-height: 1.9;
}

.order-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #eee;
    padding: 12px 14px 16px 14px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    /* 提高优先级，确保在最上层 */
}

.total {
    color: #4B5563;
    font-size: 14px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.price {
    color: var(--van-primary-color);
    font-size: 17px;
    font-weight: 500;
}

.order-btn {
    margin-top: 8px;
}

.go-face {
    display: flex;
    align-items: center;
    color: var(--van-primary-color);
    font-size: 13px;
    gap: 4px;
}

.go-face-icon {
    font-size: 16px;
}

.success-icon {
    font-size: 18px;
}

.auth-face-section {
    display: flex;
    align-items: center;
}

.auth-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
}

.auth-checkbox :deep(.van-checkbox__label) {
    margin-left: 0;
}

.auth-checkbox :deep(.van-checkbox__icon .van-icon) {
    border-radius: 5px;
}

.auth-text {
    font-size: 14px;
    color: #4B5563;
}
</style>